import { HttpService } from "./http.service";

export class DashboardPageService extends HttpService {
  async getDashboardData(): Promise<any> {
    return await this.fetchJson<any>("/user/dashboard", "GET");
  }
}
